import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import kick from "../../assets/kickfoot.png";
import baby from "../../assets/babyst.png";
import right from "../../assets/right.png";
import left from "../../assets/left.png";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";

function ChartForShare() {
  const [kickData, setKickData] = useState([]);
  const location = useLocation();
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("kickDataArray")) || [];

    if (location.state) {
      storedData.push(location.state);
    }

    setKickData(storedData);
  }, [location]);

  const sortedKickData = [...kickData].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <div style={{ backgroundColor: "#D47EA2" }} className="kicker-base">
      <div style={{ backgroundColor: "white" }} className="main-kick">
        <div className="kicker-container">
          <a href="/kick-timer">
            <button id="left-btnn">
              <img
                src={left}
                className="right-ar"
                style={{
                  animation: "bouncer 1s infinite",
                  marginRight: "20px",
                  marginTop: "-4px",
                }}
              />
              Back To Kick
            </button>
          </a>
          <a href="/contraction">
            <button id="right-btnn">
              Contraction Timer
              <img
                src={right}
                className="right-ar"
                style={{
                  animation: "bouncer 1s infinite",
                  marginLeft: "20px",
                  marginTop: "-4px",
                }}
              />
            </button>
          </a>
        </div>

        <div className=" the-cent">
          <div className="ad1 bg-dark">
            <h1>AD</h1>
          </div>
          <div className="main-contt">
            <h2 style={{ color: "#B24C76", textAlign: "center" }}>
              Baby Kick Timer
            </h2>
            <div id="chart-main-share">
              <p style={{ textAlign: "center" }}>
                The Kicks, rolls/wiggles will evolve throughout your pregnancy
                and with the Kick timer, you are able to record the number of
                kicks.
              </p>
              <p style={{ textAlign: "center" }}>
                Counting 10 movements of any kind in one to two hours tends to
                be the norm, though sometimes it can take longer.
              </p>
            </div>

            <img src={baby} alt="Trigger" className="baby-butterfly" />
            <h4 style={{ color: "#B24C76", marginTop: "20px" }}>
              You are at week {18}
            </h4>
            <p style={{ textAlign: "center" }}>
              You may feel like Butterflies fluttering in your belly at this
              stage
            </p>

            <div className="chart-tablee">
              <h2 style={{ textAlign: "center", marginTop: "20px" }}>
                Previous Kicks by Date
              </h2>
              <table className="kick-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Kicks Started at</th>
                    <th>Ended at</th>
                    <th>Number of Kicks</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedKickData.length > 0 ? (
                    sortedKickData.map((data, index) => (
                      <tr key={index}>
                        <td>{data.currentDate || "__"}</td>
                        <td>{data.startTime || "__"}</td>
                        <td>{data.endTime || "__"}</td>
                        <td>{data.totalKicks || 0}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        No kick data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Link to="/kicker/show">
              <button
                id="time3"
                style={{ background: "#B24C76", color: "white" }}
              >
                Start Counting Kicks
              </button>
            </Link>
          </div>
          <div className="ad2 bg-dark">
            <h1>AD</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChartForShare;
